<template>
  <div id="Feltonquant" class="content" style="margin: 0 auto">
    <img
      class="back-icon"
      src="../assets/img/robot/phone_back.png"
      alt="返回"
      @click="goBack"
    >
    <h4 class="modal-title">{{ $tk('robot.bot_Agreement_title') }}</h4>

    <div>
      <p
        v-for="key in openingKeys"
        :key="key"
        :class="{ 'agreement-paragraph': key !== openingKeys[0] }"
      >{{ $tk(key) }}</p>
      <div class="risk-list">
        <p
          v-for="key in riskKeys"
          :key="key"
          class="agreement-paragraph"
        >{{ $tk(key) }}</p>
      </div>
      <p
        v-for="key in closingKeys"
        :key="key"
        class="agreement-paragraph"
      >{{ $tk(key) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HedgingContractTransactionAgreement',

  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      openingKeys: [
        'robot.bot_Agreement_content1',
        'robot.bot_Agreement_content2',
        'robot.bot_Agreement_content3',
        'robot.bot_Agreement_content4'
      ],
      riskKeys: [
        'robot.bot_Agreement_content4_1',
        'robot.bot_Agreement_content4_2',
        'robot.bot_Agreement_content4_3',
        'robot.bot_Agreement_content4_4',
        'robot.bot_Agreement_content4_5',
        'robot.bot_Agreement_content4_6'
      ],
      closingKeys: [
        'robot.bot_Agreement_content5',
        'robot.bot_Agreement_content6',
        'robot.bot_Agreement_content7',
        'robot.bot_Agreement_content8'
      ]
    }
  },

  methods: {
    goBack() {
      if (this.embedded) {
        this.$emit('back')
        return
      }
      sessionStorage.setItem('goBack', '1')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.back-icon {
  position: absolute;
  top: 40px;
  height: 24px;
  vertical-align: middle;
  cursor: pointer;
}

.modal-title {
  text-align: center;
  font-size: 18px;
  margin-top: 50px;
}

p {
  font-size: 14px;
  margin: 0;
  line-height: 22px;
}

.agreement-paragraph {
  margin-top: 10px;
}

.risk-list {
  margin-left: 20px;
}

@media screen and (max-width: 900px) {
  .content {
    width: 90%;
    padding: 30px 0;
    margin: 0 auto;
    position: relative;
    bottom: 20px;
  }
}

@media screen and (min-width: 900px) {
  .content {
    width: 50%;
    padding: 30px;
    margin: 0 auto;
    position: relative;
    bottom: 20px;
  }
}
</style>
